import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';


@Component({
  selector: 'app-button-cancel-dialog',
  templateUrl: './button-cancel-dialog.component.html',
  styleUrls: ['./button-cancel-dialog.component.scss']
})
export class ButtonCancelDialogComponent implements OnInit {

  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }



}
